import { useCallback } from 'react';
import LocationPicker from './LocationPicker';

/**
 * Vendor/admin pickup location: where orders actually ship from.
 *
 * Reuses the shared LocationPicker; pickup lat/lng is used for shipping math
 * (SOHAPEYK eligibility depends on city_id) and is never shown on the
 * customer-facing storefront — the storefront exposes only the shop address.
 */
export default function PickupLocationSection({ form, setForm }) {
  const handleChange = useCallback(
    (patch) => {
      setForm((current) => {
        const next = { ...current };
        if ('location_id' in patch) next.pickup_location_id = patch.location_id;
        if ('latitude' in patch) next.pickup_latitude = patch.latitude;
        if ('longitude' in patch) next.pickup_longitude = patch.longitude;
        if ('address' in patch) next.pickup_address = patch.address;
        return next;
      });
    },
    [setForm],
  );

  return (
    <section className="admin-profile-section">
      <h2>محل تحویل سفارش‌ها (اختیاری)</h2>
      <p>
        اگر محل شرکت شما در شهر تحت پوشش ارسال نیست، محل انبار یا تحویل در شهر را
        انتخاب کنید. این موقعیت فقط برای محاسبه ارسال استفاده می‌شود و به مشتریان
        نمایش داده نمی‌شود.
      </p>
      <LocationPicker
        idPrefix="pickup"
        value={{
          location_id: form.pickup_location_id,
          latitude: form.pickup_latitude,
          longitude: form.pickup_longitude,
          address: form.pickup_address,
        }}
        onChange={handleChange}
      />
    </section>
  );
}
